import { render } from "./Paywall.vue?vue&type=template&id=2f85f4e8&scoped=true"
import script from "./Paywall.vue?vue&type=script&lang=js"
export * from "./Paywall.vue?vue&type=script&lang=js"

import "./Paywall.vue?vue&type=style&index=0&id=2f85f4e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f85f4e8"]])

export default __exports__